import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { AzureStorageService } from "../azureStorage/azure-storage.service";
import { Observable } from "rxjs";
import { ENVIRONMENT } from "../../token";

@Injectable()
export class BlobModelService {
	private api_url: string = "";

	constructor(@Inject(ENVIRONMENT) protected environment, private azure_storage_service: AzureStorageService, private http: HttpClient) {
		this.api_url = environment.api_url;
	}

	public postBlobModel(file: File, callback?: Function): void {
		this.azure_storage_service.uploadBlobToServer(file, callback);
	}

	public getBlobModelByUrl(url: string, callback?: Function): void {
		const headers = new HttpHeaders({
			"Content-Type": "application/json",
			Accept: "application/json",
		});
		this.http.get(url, { headers, responseType: "blob" as "json" }).subscribe((result) => {
			if (callback) {
				if (result) {
					callback(null, result);
				} else {
					callback(true);
				}
			}
		});
	}

	public getBlobById$(blob_id: string): Observable<any> {
		return this.http.get(this.api_url + "/v2/blobs/" + blob_id, { withCredentials: true });
	}
}
